import { render, staticRenderFns } from "./TrainingPlanItemDescription.vue?vue&type=template&id=5be0b12a&scoped=true&"
import script from "./TrainingPlanItemDescription.vue?vue&type=script&lang=ts&"
export * from "./TrainingPlanItemDescription.vue?vue&type=script&lang=ts&"
import style0 from "./TrainingPlanItemDescription.vue?vue&type=style&index=0&id=5be0b12a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be0b12a",
  null
  
)

export default component.exports